// extracted by mini-css-extract-plugin
export default {"container":"+HC1F","urlInput":"Yvm-k","button":"wGsse","error":"ULBZZ"};